import React from "react";

const WorkScheduleDistribution = ({ data = [] }) => {
  const maxVal = data.length
    ? Math.max(...data.map((item) => item.count), 1)
    : 600;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 flex flex-col justify-between h-full min-h-[320px]">
      {/* Header */}
      <div>
        <h3 className="text-sm font-semibold text-slate-800">
          Work Schedule Distribution
        </h3>
      </div>

      {/* Bars Content */}
      {data.length ? (
        <div className="flex-1 flex flex-col justify-center gap-3.5 py-2">
          {data.map((item) => {
            const barWidth = Math.round((item.count / maxVal) * 100);

            return (
              <div key={item.name} className="flex flex-col gap-1.5">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-slate-700">
                    {item.name}
                  </span>
                  <span className="text-xs text-slate-500 font-medium">
                    {item.count} ({item.percentage}%)
                  </span>
                </div>

                {/* Progress bar */}
                <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-blue-500 transition-all duration-500"
                    style={{ width: `${barWidth}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-sm text-slate-400">No data</p>
        </div>
      )}
    </div>
  );
};

export default WorkScheduleDistribution;
